import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function BeforeAfter() {
  return <section className="w-full bg-black py-16 md:py-20 px-4" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-white text-center mb-12" data-id="element-15">
          🔄 Antes vs Después
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-16">
          {/* Before */}
          <div className="bg-urgency-600/10 border border-urgency-500/30 rounded-2xl p-8" data-id="element-17">
            <h3 className="font-heading font-bold text-2xl text-urgency-500 mb-6 text-center" data-id="element-18">
              ❌ Antes del curso
            </h3>
            <div className="space-y-4" data-id="element-19">
              <div className="flex items-start gap-3" data-id="element-20">
                <XCircleIcon className="w-6 h-6 text-urgency-500 flex-shrink-0 mt-0.5" data-id="element-21" />
                <p className="font-body text-gray-300" data-id="element-22">
                  Confusión con las cartas
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-23">
                <XCircleIcon className="w-6 h-6 text-urgency-500 flex-shrink-0 mt-0.5" data-id="element-24" />
                <p className="font-body text-gray-300" data-id="element-25">Dudas constantes</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-26">
                <XCircleIcon className="w-6 h-6 text-urgency-500 flex-shrink-0 mt-0.5" data-id="element-27" />
                <p className="font-body text-gray-300" data-id="element-28">
                  Falta de práctica real
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-29">
                <XCircleIcon className="w-6 h-6 text-urgency-500 flex-shrink-0 mt-0.5" data-id="element-30" />
                <p className="font-body text-gray-300" data-id="element-31">Dependencia de otros</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-32">
                <XCircleIcon className="w-6 h-6 text-urgency-500 flex-shrink-0 mt-0.5" data-id="element-33" />
                <p className="font-body text-gray-300" data-id="element-34">
                  Sensación de no avanzar
                </p>
              </div>
            </div>
          </div>

          {/* After */}
          <div className="bg-green-600/10 border border-green-500/30 rounded-2xl p-8" data-id="element-35">
            <h3 className="font-heading font-bold text-2xl text-green-400 mb-6 text-center" data-id="element-36">
              ✅ Después del curso
            </h3>
            <div className="space-y-4" data-id="element-37">
              <div className="flex items-start gap-3" data-id="element-38">
                <CheckCircleIcon className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-39" />
                <p className="font-body text-gray-300" data-id="element-40">
                  Claridad al interpretar cartas
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-41">
                <CheckCircleIcon className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-42" />
                <p className="font-body text-gray-300" data-id="element-43">
                  Confianza en tus lecturas
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-44">
                <CheckCircleIcon className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-45" />
                <p className="font-body text-gray-300" data-id="element-46">
                  Conexión con tu intuición
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-47">
                <CheckCircleIcon className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-48" />
                <p className="font-body text-gray-300" data-id="element-49">
                  Lecturas prácticas desde el primer día
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-50">
                <CheckCircleIcon className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-51" />
                <p className="font-body text-gray-300" data-id="element-52">
                  Mayor autoconocimiento
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}